import script from "./RunawayLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./RunawayLogo.vue?vue&type=script&setup=true&lang=js"

import "./RunawayLogo.vue?vue&type=style&index=0&id=66d9c5e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66d9c5e0"]])

export default __exports__